import { getIntl } from '@ackee/jerome/antd';
import message from 'antd/lib/message';
import { getFirebase } from 'react-redux-firebase';
import { getFirestore } from 'redux-firestore';
import * as sagaEffects from 'redux-saga/effects';

import config from 'config/index';
import * as loglevel from 'config/loglevel';

import types from '../actionTypes';
import { partnersRequestCompleted } from '../actions';

const { takeEvery, put } = sagaEffects;

function* handler() {
    const firestore = getFirestore(getFirebase());
    const intl = yield getIntl();

    try {
        for (const lang of config.app.languages) {
            yield firestore.get({
                collection: `languages/${lang}/eventProperties`,
                doc: 'partners',
                storeAs: `partners<${lang}>`,
            });
        }
    } catch (e) {
        loglevel.error(e);
        message.error(intl.formatMessage({ id: 'errors.partners.detail' }));
    } finally {
        yield put(partnersRequestCompleted());
    }
}

export default function* () {
    yield takeEvery(types.PARTNERS_REQUEST, handler);
}
